import { range } from '~utils/range';
var getMatrixLine = function (maxX, y) {
    return range(maxX).map(function (_, i) {
        var x = i + 1;
        return "".concat(x, "x").concat(y);
    });
};
export { getMatrixLine };
